import styled from 'styled-components'

import { WalletModelShort } from '@root/entities/wallet/ui'
import { WalletAddressTruncated } from '@root/entities/wallet/ui/common/wallet-address-truncated'

import type { WalletModel } from '@root/entities/wallet/atoms/reatom-wallet'

type Props = {
  wallet: WalletModel
}

export const NOTIFICATION_WIDGET_WALLETS_ITEM_HEIGHT = 40

export const NotificationWidgetWalletsItem = ({ wallet }: Props) => (
  <Slide>
    <WalletItem>
      <WalletModelShort wallet={wallet} size="xs" />
      <Address walletAddress={wallet.address} withCopy />
    </WalletItem>
  </Slide>
)

const Slide = styled.div`
  display: grid;
  align-items: center;
`

const WalletItem = styled.div`
  background: rgba(0, 0, 0, 0.3);

  display: grid;
  align-items: center;
  justify-content: space-between;
  justify-items: start;
  align-content: center;

  height: ${NOTIFICATION_WIDGET_WALLETS_ITEM_HEIGHT}px;
  padding-inline: 10px;
  border-radius: 8px;
`

const Address = styled(WalletAddressTruncated)`
  color: var(--text-9);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`
